export const currentOTPDeliveryMethod = (state) =>
  state.userAttributes.attributes?.OTPDeliveryMethod;
